import React, { createContext, useContext, useReducer } from 'react';

const ProcessingContext = createContext();

const initialState = {
  currentStep: 'upload',
  uploadedFiles: [],
  processedFiles: [],
  processing: false,
  error: null,
  progress: 0
};

function processingReducer(state, action) {
  switch (action.type) {
    case 'SET_STEP':
      return { ...state, currentStep: action.payload };
    case 'SET_UPLOADED_FILES':
      return { ...state, uploadedFiles: action.payload };
    case 'ADD_UPLOADED_FILE':
      return { 
        ...state, 
        uploadedFiles: [...state.uploadedFiles, action.payload] 
      };
    case 'SET_PROCESSED_FILES':
      return { ...state, processedFiles: action.payload };
    case 'ADD_PROCESSED_FILE':
      return { 
        ...state, 
        processedFiles: [...state.processedFiles, action.payload] 
      };
    case 'SET_PROCESSING':
      return { ...state, processing: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload, processing: false };
    case 'SET_PROGRESS':
      return { ...state, progress: action.payload };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

export function ProcessingProvider({ children }) {
  const [state, dispatch] = useReducer(processingReducer, initialState);

  const setCurrentStep = (step) => {
    dispatch({ type: 'SET_STEP', payload: step });
  };

  const addUploadedFile = (file) => {
    dispatch({ type: 'ADD_UPLOADED_FILE', payload: file });
  };

  const setUploadedFiles = (files) => {
    dispatch({ type: 'SET_UPLOADED_FILES', payload: files });
  };

  const addProcessedFile = (file) => {
    dispatch({ type: 'ADD_PROCESSED_FILE', payload: file });
  };

  const setProcessedFiles = (files) => {
    dispatch({ type: 'SET_PROCESSED_FILES', payload: files });
  };

  const setProcessing = (processing) => {
    dispatch({ type: 'SET_PROCESSING', payload: processing });
  };

  const setError = (error) => {
    dispatch({ type: 'SET_ERROR', payload: error });
  };

  const setProgress = (progress) => {
    dispatch({ type: 'SET_PROGRESS', payload: progress });
  };

  const reset = () => {
    dispatch({ type: 'RESET' });
  };

  const value = {
    ...state,
    setCurrentStep,
    addUploadedFile,
    setUploadedFiles,
    addProcessedFile,
    setProcessedFiles,
    setProcessing,
    setError,
    setProgress,
    reset
  };

  return (
    <ProcessingContext.Provider value={value}>
      {children}
    </ProcessingContext.Provider>
  );
}

export function useProcessing() {
  const context = useContext(ProcessingContext);
  if (!context) {
    throw new Error('useProcessing must be used within a ProcessingProvider');
  }
  return context;
}